<template>
    <div class="spinner" :style="spinner" :class="mini ? 'd-flex justify-content-center align-items-center' : ''">
        <div 
            v-for="i in 5" 
            :key="i" :class="`rect${i}`" 
            :style="rect"
        ></div>
    </div>
</template>

<script>
export default {
    name: 'LoadingSpinner',
    props: {
        mini: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        color() {
            return this.$store.getters.COLOR
        },
        spinner() {
            return {
                margin: this.mini ? 'auto' : '50px auto',
                width: '90px',
                height: '100px',
                textAlign: 'center',
                fontSize: '10px'
            }
        },
        rect() {
            return { 
                backgroundColor: this.color.primary,
                height: this.mini ? '70%' : '100%'
            }
        }
    }
}
</script>

<style>

.spinner > div {
  width: 6px;
  display: inline-block;
  margin: 0 2px;
  
  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.spinner .rect3 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

.spinner .rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.spinner .rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

@-webkit-keyframes sk-stretchdelay {
  0%, 40%, 100% { -webkit-transform: scaleY(0.4) }  
  20% { -webkit-transform: scaleY(1.0) }
}

@keyframes sk-stretchdelay {
  0%, 40%, 100% { 
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }  20% { 
    transform: scaleY(1.0);
    -webkit-transform: scaleY(1.0);
  }
}
</style>
